import { init } from '@sentry/react';

// eslint-disable-next-line no-unused-vars
const API_STATUS_CODES = [400, 401, 404];
const IGNORE_APIS = [];
const IGNORE_THIRD_PARTY_FAILURE = ['ChunkLoadError'];

const IGNORE_ERRORS = [
  'unknown',
  'pause',
  'resume',
  'Illegal invocation',
  '@derivedConstructor',
  'Network Error',
  /Request failed with status code (400|401|404)/,
];

export const initSentry = () => {
  if (process.env.REACT_APP_ENV !== 'prod') return;

  init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    ignoreErrors: IGNORE_ERRORS,
    tracesSampleRate: 0.1,
    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i],
    beforeSend(event, hint) {
      const err = hint.originalException;
      if (
        (err &&
          err.config &&
          err.request &&
          err.config.url &&
          IGNORE_APIS.filter(
            (item) =>
              (err.config.url.indexOf(item.endpoint) >= 0 &&
                item.status.filter(
                  (statusCode) => err.request.status === statusCode
                ).length) ||
              (err.path && err.path.indexOf(item.endpoint) >= 0)
          ).length) ||
        err.errorCode
      ) {
        return null;
      }
      if (
        (err &&
          err.stack &&
          IGNORE_THIRD_PARTY_FAILURE.filter(
            (item) => err.stack.indexOf(item) >= 0
          ).length) ||
        err.stack === undefined
      ) {
        return null;
      }
      return event;
    },
  });
};
